import React, { useState } from 'react';
import api from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm: '' });
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (form.new_password.length < 6) { toast.error('New password must be at least 6 characters'); return; }
    if (form.new_password !== form.confirm) { toast.error('New passwords do not match'); return; }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { current_password: form.current_password, new_password: form.new_password });
      toast.success('Password changed successfully');
      setForm({ current_password: '', new_password: '', confirm: '' });
      onOpenChange(false);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Failed to change password'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="font-heading">Change Password</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Current Password</Label><Input type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="change-password-current" className="mt-1.5" /></div>
          <div><Label>New Password</Label><Input type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="change-password-new" className="mt-1.5" /></div>
          <div><Label>Confirm New Password</Label><Input type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="change-password-confirm" className="mt-1.5" /></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button><Button onClick={submit} disabled={saving} data-testid="change-password-submit">Update Password</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
